/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { isEmpty } from 'lodash';

import { Button } from '@atoms';
import { AlertBox } from '@molecules';

import styles from './AcceptTermsModal.module.scss';

import { Dispatch, RootState } from '../../../store';

function AcceptTermsModal() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { me } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch<Dispatch>();
  const CONSOLE_POLICY_LINK = window.fromServer.env.ACCEPTABLE_USE_LINK;

  return (
    <AlertBox display={!isEmpty(me) && !me?.accepted_terms}>
      <div className={styles.acceptTermsAlert}>
        <Trans i18nKey="modal.accept_terms_two_tier">
          <h3 data-testid="modal.accept_terms_two_tier_title">
            YubiEnterprise Console Acceptable Use Policy
          </h3>
          <p>
            To access YubiEnterprise console, please review and agree to the Acceptable Use Policy which is
            located at:
          </p>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={CONSOLE_POLICY_LINK}
            data-testid="console-policy-link"
          >
            <>{{ CONSOLE_POLICY_LINK }}</>
          </a>
          <p>If you do not agree with the stated policy, you will be logged out of YubiEnterprise Console.</p>
        </Trans>

        <div className={styles.buttonContainer}>
          <Button
            variant="anchor"
            onClick={() => {
              dispatch.auth.userLogout().then(() => navigate('/login'));
            }}
            data-testid="button.disagree_terms"
          >
            {t('button.disagree_terms')}
          </Button>
          <Button
            onClick={() => {
              dispatch.auth.acceptTerms();
            }}
            data-testid="button.agree_terms"
          >
            {t('button.agree_terms')}
          </Button>
        </div>
      </div>
    </AlertBox>
  );
}

export default AcceptTermsModal;
